import styled from 'styled-components';

export const Descriptor = styled.div(({ theme }) => ({
  color: theme.defaultTheme.black,
  textAlign: 'center',
  fontSize: '20rem',
  letterSpacing: 0,
  opacity: 1,
  padding: '10rem',
  display: 'flex',
  flexDirection: 'column',
}));

export const Container = styled.div({
  height: '100%',
  marginTop: '20rem',
  borderRadius: '5rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  '& span': {
    textAlign: 'left',
  },
});
